import { render, staticRenderFns } from "./StatisticsReports.vue?vue&type=template&id=5c8ab220&"
import script from "./StatisticsReports.vue?vue&type=script&lang=js&"
export * from "./StatisticsReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports